import React, { ChangeEvent, FocusEvent, PropsWithChildren, useEffect, useState } from 'react'
import validator from 'validator'

interface ColorPickerProps {
  value?: string
  id?: string
  name?: string
  className?: string
  required?: boolean
  onBlur?: (event: FocusEvent<HTMLInputElement>) => void
  onFocus?: (event: FocusEvent<HTMLInputElement>) => void
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void
}

const hashCSSProps: React.CSSProperties = {
  position: 'absolute',
  top: '7px',
  left: '50px',
  bottom: '0px',
  zIndex: 100,
  pointerEvents: 'none',
}

export const ColorPicker = (props: PropsWithChildren<ColorPickerProps>): React.ReactElement => {
  const { onBlur: handleBlur, onFocus: handleFocus, name, id } = props
  const [value, setValue] = useState<string | undefined>(props?.value)
  useEffect(() => {
    let value = props?.value
    if (value) {
      value = value.replace(/[^A-Fa-f0-9]/g, '').substring(0, 6)
    }
    setValue(value)
  }, [props])
  const handleChange = (event: ChangeEvent<HTMLInputElement>): void => {
    let value: string = event.target.value
    if (event.target.value) {
      value = event.target.value.replace(/[^A-Fa-f0-9]/g, '').substring(0, 6)
    }
    setValue(value)
    if (props.onChange && (validator.isHexColor(event.target.value) || !event.target.value)) {
      props.onChange(event)
    }
  }
  const colorStyle = value && validator.isHexColor(value) ? { backgroundColor: `#${value}` } : {}
  return (
    <div className="input-group color-picker">
      <label
        htmlFor={id || 'color'}
        className="form-control"
        style={{ ...colorStyle, maxWidth: '2.5rem' }}
      />
      <input
        name={name}
        id={id || 'color'}
        type="color"
        aria-label="Color"
        className="form-control"
        style={{ maxHeight: 0, maxWidth: 0, opacity: 0, padding: 0, margin: -2 }}
        value={typeof value !== 'undefined' ? `#${value}` : ''}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onChange={(e: ChangeEvent<HTMLInputElement>): void => {
          handleChange(e)
        }}
      />
      <div className="text-body-secondary border-0" style={hashCSSProps}>
        #
      </div>
      <input
        name={name}
        type="text"
        aria-label="Color"
        className="form-control ps-4"
        value={value}
        style={{ minWidth: '90px' }}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onChange={(e: ChangeEvent<HTMLInputElement>): void => {
          handleChange(e)
        }}
      />
    </div>
  )
}
